@if (cleaning.template === 'pending_availability_request' && cleaning.template_data.request_type === 'countered') {
  <tidy-card>
    <tidy-label>{{cleaning.template_data.homekeeper.homekeeper_name}} proposed other times</tidy-label>
    <div class="countered-text">
      {{cleaning.template_data.homekeeper.homekeeper_name}} indicated they were not available for the times you requested,
      but provided other times they are available.
    </div>
    <div class="item-options">
      <tidy-card-item tappable>
        <ion-icon item-left name="ios-calendar-outline"  class="grey-icon" />
        <tidy-link
          (click)="goToRequestCounteredTimes(cleaning.template_data.availability_request, cleaning.template_data.homekeeper)"
          item-right
          >
          View Other Times
        </tidy-link>
      </tidy-card-item>
    </div>
  </tidy-card>
}

@if (cleaning.template === 'pending_availability_request' && cleaning.template_data.request_type === 'pending') {
  <tidy-card>
    <tidy-label>
      Time request pending with {{cleaning.template_data.homekeeper.homekeeper_name}} for a
      {{ cleaning.template_data.availability_request.service_type | typePlanFormat}}
      <frequency-request-times
        [frequency]="cleaning.template_data.availability_request.frequency"
      >:</frequency-request-times>
    </tidy-label>
    <list-request-times [times]="cleaning.template_data.availability_request.request_times" />
    <tidy-label class="edit-and-cancel-request">Options</tidy-label>
    <div class="item-options">
      <tidy-card-item tappable>
        <img class="pencil-icon" item-left src="assets/img/icons/pencil-icon.svg">
        <tidy-link (click)="goToEditRequestTimes(cleaning.template_data.availability_request, cleaning.template_data.homekeeper)" item-right>
          Edit Request
        </tidy-link>
      </tidy-card-item>
      <tidy-card-item tappable>
        <img class="trash-icon" item-left src="assets/img/icons/trash-icon-outline.svg">
        <tidy-link
          (click)="goToCancelRequest(cleaning.template_data.availability_request, cleaning.template_data.homekeeper.homekeeper_name)"
          item-right
          >
          Cancel Request
        </tidy-link>
      </tidy-card-item>
    </div>
  </tidy-card>
}
